import React from "react";

const TablaListaSeleccionMaestroProcedimiento = ({item, passAgregarPorce}) => {
  const maestroProcedimiento={
    codigoProcedimiento:item.PRCODI,
    nombreProcedimiento:item.PrNomb
  }

  const handleOnclickMaestro=()=>{
    passAgregarPorce(maestroProcedimiento)
  }
  return (
    <tr className="border-b" >
      <td className="text-xs font-medium py-2 whitespace-pre-wrap"><button
                type="button"
                onClick={handleOnclickMaestro}
                className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Seleccionar
              </button>
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PRCODI}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.PrNomb}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PClCod}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap"></td>
    </tr>
  );
};

export default TablaListaSeleccionMaestroProcedimiento;
